import React from 'react';
import { Typography, Box, IconButton, Stack } from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';

const iconMap = {
  github: GitHubIcon,
  linkedin: LinkedInIcon,
  email: EmailIcon,
  scholar: SchoolOutlinedIcon,
};

const Hero = ({ name, title, about, profileImage, social, layoutSideBySide }) => (
  <Box sx={{
    minHeight: { xs: 'auto', md: '60vh' },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    bgcolor: 'background.default',
    pt: { xs: 6, md: 10 },
    pb: { xs: 4, md: 8 },
    px: { xs: 2, md: 0 },
  }}>
    <Stack
      direction={{ xs: 'column', md: layoutSideBySide ? 'row' : 'column' }}
      spacing={{ xs: 4, md: layoutSideBySide ? 8 : 4 }}
      alignItems="center"
      justifyContent="center"
      sx={{ width: '100%', maxWidth: 1100 }}
    >
      <Box
        component="img"
        src={profileImage}
        alt={name}
        sx={{
          width: { xs: 180, sm: 260, md: layoutSideBySide ? 340 : 260 },
          height: { xs: 180, sm: 260, md: layoutSideBySide ? 340 : 260 },
          objectFit: 'cover',
          borderRadius: { xs: 2, md: 2 },
          mb: { xs: 2, md: 0 },
          boxShadow: 0,
        }}
      />
      <Box sx={{ textAlign: { xs: 'center', md: layoutSideBySide ? 'left' : 'center' }, maxWidth: 700 }}>
        <Typography variant="h2" fontWeight={700} gutterBottom sx={{ letterSpacing: 1, fontFamily: 'Montserrat, sans-serif', fontSize: { xs: 24, sm: 32, md: 36 } }}>
          {name}
        </Typography>
        <Typography variant="h5" fontWeight={400} color="text.secondary" gutterBottom sx={{ mb: 2, fontFamily: 'Montserrat, sans-serif', fontSize: { xs: 16, sm: 18, md: 20 } }}>
          {title}
        </Typography>
        <Typography 
          variant="body1" 
          sx={{ 
            mb: 3, 
            color: 'text.secondary', 
            fontSize: { xs: 14, sm: 16, md: 18 },
            '& a': {
              color: 'primary.main',
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline'
              }
            }
          }}
          dangerouslySetInnerHTML={{ __html: about }}
        />
        <Stack direction="row" spacing={2} justifyContent={{ xs: 'center', md: layoutSideBySide ? 'flex-start' : 'center' }} flexWrap="wrap">
          {social.map(({ icon, url }) => {
            const Icon = iconMap[icon];
            return (
              <IconButton 
                color="primary" 
                href={url} 
                target="_blank" 
                key={icon} 
                size="large"
                sx={{ 
                  '& .MuiSvgIcon-root': {
                    fontSize: { xs: '1.5rem', sm: '1.8rem' }
                  }
                }}
              >
                <Icon fontSize="inherit" />
              </IconButton>
            );
          })}
        </Stack>
      </Box>
    </Stack>
  </Box>
);

export default Hero; 